import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, map, tap } from "rxjs/operators";
import { share } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { LoadingService } from "../shared/services/loading.service";
import { SkipLoaderService } from "../shared/services/skip-loader.service";

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private loader: LoadingService, 
    private toastr: ToastrService,
    private skipLoaderService: SkipLoaderService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser: any = localStorage.getItem("currentUser") ? JSON.parse(localStorage.getItem("currentUser") || '') : "";
    if (currentUser) {
      request = request.clone({
        headers: request.headers.set("Authorization", "Bearer " + currentUser.token),
      });
    }

    request = request.clone({
      headers: request.headers.set("Accept", "application/json"),
    });

    const skipLoader = this.skipLoaderService.getSkipLoader();
    
    if (!skipLoader) {
      this.loader.show();
    }
    
    const req: Observable<HttpEvent<any>> = next
      .handle(request)
      .pipe(
        share(),
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          if (request.method !== 'GET') {
            if (event.body && event.body.success) {
              this.toastr.success(event.body.message, '', {});
            } else if (event.body && !event.body.success) {
              this.toastr.error(event.body.message, 'Attenzione!', {});
            }
          }
        }
        }),
        catchError((err) => {
          if (err.status === 401 && !window.location.href.includes("/pages/login")) {
            localStorage.removeItem("currentUser");
            window.location.href = window.location.origin + "/pages/login";
          } else {
            //generic error
            this.toastr.error("Problema di rete", err.error?.message, {
              positionClass: "toast-bottom-left",
            });
          }

          const skipLoader = this.skipLoaderService.getSkipLoader();
          if (!skipLoader) {
            this.loader.hide();
          }

          return throwError(err);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            const skipLoader = this.skipLoaderService.getSkipLoader();
            if (!skipLoader) {
              this.loader.hide();
            }
          }
          return evt;
        })
      );
    return req;
  }
}
